// extracted by css-extract-rspack-plugin
export default {"fieldLabel":"PromotionPriceField_fieldLabel__5mybe","button":"PromotionPriceField_button__bcnFa"};